import { createLazyOrchestrator } from 'owa-bundling';
import { resetSearchStore } from 'owa-calendar-search-store';
import { SearchScenarioId, searchSessionEnded } from 'owa-search';
import { setSearchActive } from 'owa-suite-header-apis';

export const searchSessionEndedOrchestrator = createLazyOrchestrator(
    searchSessionEnded,
    'CLONE_CALENDAR_SEARCH_SESSION_ENDED',
    actionMessage => {
        if (actionMessage.scenarioId != SearchScenarioId.Calendar) {
            return;
        }

        // reset the calendar search store
        resetSearchStore();

        // set the search state
        setSearchActive(false);
    }
);

export { SearchScenarioId };
